import { render, staticRenderFns } from "./ClaimPdfContent.vue?vue&type=template&id=d905392a&scoped=true&"
import script from "./ClaimPdfContent.vue?vue&type=script&lang=js&"
export * from "./ClaimPdfContent.vue?vue&type=script&lang=js&"
import style0 from "./ClaimPdfContent.vue?vue&type=style&index=0&id=d905392a&prod&lang=scss&scoped=true&"
import style1 from "./ClaimPdfContent.vue?vue&type=style&index=1&id=d905392a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d905392a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
